import React, { useState, useEffect } from "react";
import api from '../../api/axiosInstance';
import UserLayout from "../../components/user/UserLayout";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaFlask } from "react-icons/fa";
import "./FormulasPage.css";

const FormulasPage = () => {
  const [formulas, setFormulas] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("Hepsi");
  const [sort, setSort] = useState("recent");

  useEffect(() => {
    api.get("/formulas").then((res) => {
      setFormulas(res.data);
      setFiltered(res.data);
    });
  }, []);

  const categories = [
    "Hepsi",
    ...new Set(formulas.map((f) => f.indication).filter(Boolean)),
  ];

  useEffect(() => {
    let data = [...formulas];

    if (search.trim() !== "") {
      data = data.filter(
        (f) =>
          f.formulationName.toLowerCase().includes(search.toLowerCase()) ||
          f.content.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category !== "Hepsi") {
      data = data.filter((f) => f.indication === category);
    }

    // Sort
    if (sort === "recent") {
      data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (sort === "az") {
      data.sort((a, b) => a.formulationName.localeCompare(b.formulationName));
    } else if (sort === "za") {
      data.sort((a, b) => b.formulationName.localeCompare(a.formulationName));
    }

    setFiltered(data);
  }, [search, category, sort, formulas]);

  return (
    <UserLayout>
      <h3 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
        💊 Majistral Formüller
      </h3>

      {/* 🔎 Arama + Sıralama */}
      <Card className="p-3 shadow-sm mb-3">
        <Row className="g-3">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Formül ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>

          <Col md={6}>
            <Form.Select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="recent">En Yeni</option>
              <option value="az">A → Z</option>
              <option value="za">Z → A</option>
            </Form.Select>
          </Col>
        </Row>
      </Card>

      {/* 🟦 Kategori Tag Satırı */}
      <div className="category-chip-container mb-4">
        {categories.map((cat, i) => (
          <button
            key={i}
            className={`category-chip ${category === cat ? "active" : ""}`}
            onClick={() => setCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* GRID Kartlar */}
      <Row className="g-4">
        {filtered.map((f) => (
          <Col xs={12} sm={6} md={4} lg={3} key={f._id}>
            <Card
              className="shadow-sm p-3 h-100 hover-scale"
              style={{ borderRadius: "15px" }}
            >
              <div className="d-flex align-items-center">
                <FaFlask size={26} color="#2D8A7A" className="me-2" />
                <h5 className="fw-bold mb-0" style={{ fontSize: "1.1rem" }}>
                  {f.formulationName}
                </h5>
              </div>

              <p className="text-muted mt-2" style={{ fontSize: "0.9rem" }}>
                {f.content.substring(0, 80)}...
              </p>

              <Button
                href={`/formul/${f._id}`}
                variant="primary"
                className="w-100 mt-3"
              >
                İncele
              </Button>
            </Card>
          </Col>
        ))}
      </Row>

      {filtered.length === 0 && (
        <p className="text-center mt-4 text-muted">Sonuç bulunamadı.</p>
      )}
    </UserLayout>
  );
};

export default FormulasPage;
